<template>
  <div class="relative p-4 border-t-4 rounded-lg w-80 border-light-purple-100 bg-pure-white">
    <div class="space-y-2">
      <div class="w-16 h-4 rounded-full bg-slate-300" />
      <div class="w-64 h-4 rounded-full bg-slate-300" />
      <div class="w-48 h-4 rounded-full bg-slate-300" />
    </div>
    <div class="py-8 space-y-4">
      <div class="flex flex-wrap items-center content-center justify-center gap-x-2 gap-y-3 h-84">
        <!-- default prompt get boxes independent -->
        <div v-for="prompt in promptGetBoxes()" :key="prompt.id" class="space-y-1">
          <div v-if="prompt.is_default"
            class="relative flex items-center justify-center flex-shrink-0 w-20 h-20 rounded-3xl" :style="{
              backgroundColor: '#F2FBF9',
              color: '#1D847F'
            }">
            <div class="text-2xl font-bold">{{ prompt.abbreviation }}</div>
          </div>
          <div v-else class="relative flex items-center justify-center flex-shrink-0 w-20 h-20 rounded-3xl" :style="{
            backgroundColor: '#F2FBF9',
            color: '#1D847F'
          }">
            <div class="text-2xl font-bold">{{ prompt.abbreviation }}</div>
          </div>
        </div>

      </div>
      <div v-if="promptPageCount > 1" class="flex items-center justify-center gap-2">
        <button v-for="n in promptPageCount" :key="n" :class="n - 1 === promptPageIndex ? 'bg-light-purple' : ''"
          class="w-2 h-2 border rounded-full outline-none border-light-purple"
          @click.prevent="promptPageIndex = n - 1" />
      </div>
    </div>
    <BlInputButton v-if="promptPageCount > 1" class="absolute border rounded-full border-light-purple"
      :style="{ top: '50%', left: '-4rem', transform: 'translate(0, -50%)' }" icon="chevron-left" type="plain"
      :disabled="promptPageIndex === 0" @clicked="promptPageIndex--" />
    <BlInputButton v-if="promptPageCount > 1" class="absolute border rounded-full border-light-purple"
      :style="{ top: '50%', right: '-4rem', transform: 'translate(0, -50%)' }" icon="chevron-right" type="plain"
      :disabled="promptPageIndex === promptPageCount - 1" @clicked="promptPageIndex++" />
  </div>
</template>

<script>
import BlInputButton from "../../BlInputButton.vue";

export default {
  name: "PromptingPreview",
  components: { BlInputButton },
  props: ["prompts"],
  data() {
    return {
      promptPageIndex: 0
    };
  },
  computed: {
    promptPageLimit() {
      return 9;
    },
    promptPageCount() {
      const totalBoxes = this.prompts.length;
      return Math.ceil(totalBoxes / this.promptPageLimit);
    }
  },
  mounted() {
    this.promptPageIndex = 0;
  },
  methods: {
    promptGetBoxes() {
      const sortedPrompts = [...this.prompts].sort((a, b) => a.position - b.position).sort((a, b) => b.score - a.score);
      const start = this.promptPageIndex * this.promptPageLimit;
      const end = (this.promptPageIndex + 1) * this.promptPageLimit;
      return sortedPrompts.slice(start, end);
    }
  }
};
</script>



// WEBPACK FOOTER //
// src/components/repository/sbt/PromptingPreview.vue